import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultTrue} from 'module/Properties/util/PropertiesUtil'

export const PersurlUserConfigDict = {
	enabled: {
		label: "Ganztägige Abwesenheiten",
		type: 'boolean',
		defaultValue: true,
		defaultOverrideSelector: selPropGen(PropID.persurlDefault, propDefaultTrue),
		visibleSelector: selPropGen(PropID.persurlVis, propDefaultTrue),
	},
} as const